module.exports = __webpack_public_path__ + "81803b58a306fa08801710b617420f65.gif";